<template>
  <div id="printable" class="content-wrapper">
    <section class="history project-history">
      <h1>{{ $t("project.projectHistory.header") }}</h1>
      <h2 class="report-subhead">Plan: <strong>{{ project.planName }}</strong></h2>
      <h2 class="report-subhead">Group: <strong>{{ project.groupName }}</strong></h2>
      <h2 class="report-topic">Project: <strong>{{ project.name }}</strong></h2>
    </section>
    <CreditHistory
      v-if="this.historyData.length > 0"
      v-bind:historyData="this.historyData"
    />
    <h4 v-else class="error">{{ $t("project.projectHistory.errorMsg") }}</h4>
  </div>
</template>

<script>
import CreditHistory from '@/components/CreditHistory.vue'

import { projectService } from '@/services/project.service'

export default {
  name: 'ProjectHistory',
  components: {
    CreditHistory
  },
  data: function () {
    return {
      project: {},
      historyData: []
    }
  },
  created: function () {
    this.fetchData()
    this.fetchProject()
  },
  methods: {
    fetchProject: function () {
      projectService.getProject(this.$route.params.projectId).then(project => {
        this.project = project
      }).catch(err => {
        console.error('something went wrong fetching project: ', err)
      })
    },
    fetchData: function () {
      projectService.meterEvents(this.$route.params.projectId).then((data) => {
        this.historyData = data.reverse()
      }).catch(err => {
        console.error('something went wrong fetching project credit history: ', err)
      })
    }
  }
}
</script>
